import { render, staticRenderFns } from "./PowerRewriteMain.vue?vue&type=template&id=c4b9c296&scoped=true"
import script from "./PowerRewriteMain.vue?vue&type=script&lang=js"
export * from "./PowerRewriteMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b9c296",
  null
  
)

export default component.exports